document.addEventListener('crowdfunding:added-to-cart', (event) => {
  event.preventDefault();

  const sections = [
    { id: 'Cart',               section: 'main-cart',   selector: '.thb-cart-form' },
    { id: 'Cart-Drawer',        section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' },
  ];

  fetch(`${window.location.pathname}?sections=${sections.map((s) => s.section).join(',')}`)
    .then((r) => r.json())
    .then((rendered) => {
      sections.forEach(({ id, section, selector }) => {
        const container = document.getElementById(id);
        if (!container || !rendered[section]) return;

        const target = container.querySelector(selector) || container;
        const parsed = new DOMParser().parseFromString(rendered[section], 'text/html');
        const inner  = parsed.querySelector(selector);
        target.innerHTML = inner ? inner.innerHTML : parsed.body.innerHTML;
      });

      const cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer) cartDrawer.open();
    })
    .catch(console.error);
});
